import { render } from "./PublicationPage.vue?vue&type=template&id=942521a2"
import script from "./PublicationPage.vue?vue&type=script&lang=js"
export * from "./PublicationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__